import React, { useEffect, useState } from "react";
import DocumentMeta from "react-document-meta";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Layout from "./Layout";
// import KeyboardEventHandler from 'react-keyboard-event-handler'

import RundownInternals from "./shared/RundownInternals";

export default function Rundown() {
	const { projectId } = useParams();
	const selectedProject = useSelector(
		(state) => state.main.projects?.[projectId]
	);
	const cueToEdit = useSelector((state) => state.rundown.cueToEdit);
	const cues = selectedProject?.cues;

	const [addingGraphic, setAddingGraphic] = useState(false);

	const meta = {
		title: `Rundown - ${selectedProject?.name}`,
	};

	useEffect(()=>{
		document.body.style.backgroundColor = 'black'
	}, [])

	return (
		<DocumentMeta {...meta}>
			<Layout overflow="auto">
				{/* <KeyboardEventHandler
					handleKeys={["alphanumeric"]}
					onKeyEvent={(key, e) => {
						e.preventDefault();
						if(key === 'a') {
							console.log('a')
						} else if (key === 'b') {
							console.log('b')
						} else {
							console.log('all')
						}
						// return cuesApi.runCues(projectId);
					}}
				/> */}
				<RundownInternals
					selectedProject={selectedProject}
					cueToEdit={cueToEdit}
					cues={cues}
					addingGraphic={addingGraphic}
					setAddingGraphic={setAddingGraphic}
				/>
			</Layout>
		</DocumentMeta>
	);
}
